import { useContext, useMemo } from "react";
import { usePromiseTracker } from "react-promise-tracker";
import { ThreeDots, Dna } from "react-loader-spinner";
import { ThemeContext } from "../../contexts";

// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "./loadingIndicator.css";

const Loading = (): JSX.Element => {
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), []);
	const { theme } = useContext(ThemeContext);

	return (
		<div className={urlSearchParams.get("step") ? "loader-2" : "loader"}>
			<Dna visible={true} height="80" width="80" />
		</div>
	);
};

const LoadingIndicator = (): JSX.Element => {
	const { promiseInProgress } = usePromiseTracker();
	if (promiseInProgress) {
		return <Loading />;
	} else return <></>;
};

export default LoadingIndicator;
